import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';

import { AppState } from 'common/appState';
import { getBenefitsDashboard } from 'features/benefit/selectors/benefitSelectors';
import { BenefitDashboardRow, BenefitDashboardTab } from 'features/benefit/models/benefitModels';
import { isLoadingRole, isTenant, isAdmin } from 'features/user/selectors/userSelectors';
import {
    saveFilters,
    clearFilters,
    paginationRequest,
} from 'features/pagination/actions/paginationActions';
import { getFilterParams } from 'features/pagination/selectors/paginationSelectors';
import { getBenefitsCSVRequest } from 'features/download/actions/downloadActions';
import { getFetchingDownloadStatus } from 'features/download/selectors/downloadSelectors';
import { PaginationFilters } from 'features/pagination/reducers/paginationReducer';
import { PaginationView } from 'features/pagination/models/paginationModel';

import { BenefitsDashboard } from '../components/BenefitsDashboard';

interface TabParam {
    tab?: string;
}

interface BenefitsDashboardStateProps {
    loading: boolean;
    isUserTenant: boolean;
    isUserAdmin: boolean;
    benefits: BenefitDashboardRow[];
    activeTab: BenefitDashboardTab;
    filter?: PaginationFilters;
    isFetchingCSV: boolean;
}

interface BenefitsDashboardDispatchProps {
    saveFilters: typeof saveFilters;
    clearFilters: typeof clearFilters;
    paginationRequest: typeof paginationRequest;
    getBenefitsCSVRequest: typeof getBenefitsCSVRequest;
}

export type BenefitsDashboardContainerProps = BenefitsDashboardStateProps &
    BenefitsDashboardDispatchProps;

const isKnownTab = (tab?: string): tab is BenefitDashboardTab =>
    Object.values(BenefitDashboardTab).some((known) => known === tab);

const mapStateToProps = (
    state: AppState,
    ownProps: RouteComponentProps<TabParam>,
): BenefitsDashboardStateProps => {
    const { tab } = ownProps.match.params;

    return {
        loading: isLoadingRole(state),
        isUserTenant: isTenant(state),
        isUserAdmin: isAdmin(state),
        benefits: getBenefitsDashboard(state),
        // An unknown or missing tab segment falls back to Overdue rather than showing nothing.
        activeTab: isKnownTab(tab) ? tab : BenefitDashboardTab.Overdue,
        filter: getFilterParams(state, PaginationView.BenefitsDashboard),
        isFetchingCSV: getFetchingDownloadStatus(state),
    };
};

export const BenefitsDashboardContainer = connect(mapStateToProps, {
    saveFilters,
    clearFilters,
    paginationRequest,
    getBenefitsCSVRequest,
})(BenefitsDashboard);
